<template>
  <div class="bg-white p-3 messenger">
    <div class="row mb-3">
      <div class="col-md-12 top">
        <router-link class="return" :to="{
            name: 'Group List'
          }">
          <i class="fas fa-chevron-left"></i>
          {{ $t("events.newEvent.back") }}
        </router-link>
        <h1 class="mt-2">{{ $t("groups.details") }}</h1>
      </div>
    </div>

    <div class="row p-5">
      <div class="col-md-6 pl-5">
        <label class="bolded">{{ $t("groups.nameGroup") }}: {{groupDetailInfo.chatName}}</label>
        <div class="group-image-container">
          <div v-if="groupDetailInfo.image === '' " class="gray-image-detail">
            <span>No Image</span>
          </div>
          <div v-else class="group-image">
            <img class="image-group" :src="groupDetailInfo.image" />
            <i
              v-if="groupDetailInfo.image !==''"
              @click="openModal"
              class="far fa-trash-alt delete-icon-detail"
            ></i>
          </div>
        </div>

        <label class="bolded mt-2">{{ $t("groups.table.headings.createdAt") }}</label>
        <p>{{groupDetailInfo.createdAt}}</p>
      </div>
      <div class="col-md-6 pl-5">
        <label class="bolded">{{ $t("groups.admin") }}</label>
        <p
          v-for="(admin, index) in groupDetailInfo.bossControlNumbers"
          :key="index"
        >{{admin.name}} {{admin.lastName}} {{admin.mothersLastName}}, {{admin.uo}}, {{admin.controlNumber}}</p>
        <label class="bolded">{{ $t("groups.members") }} ({{groupDetailInfo.members.length}})</label>
        <ol class="pl-3">
          <li
            v-for="(member, index) in groupDetailInfo.members"
            :key="index"
          >{{member.name}} {{member.lastName}} {{member.mothersLastName}}, {{member.uo}}, {{member.controlNumber}}</li>
        </ol>
      </div>
    </div>
    <Modal v-if="modalActive" @closeModal="closeModal">
      <template #header>
        <h6 class="modal-title">{{$t('news.details.modal.title')}}</h6>
      </template>
      <template>
        <p>{{$t('groups.modalAlertTitle')}}</p>
        <p>{{$t('groups.modalAlertSubtitle')}}</p>
      </template>
      <template #footer>
        <div class="controls">
          <span
            class="control cancel-btn mr-3"
            @click="closeModal"
          >{{$t('news.details.modal.cancel')}}</span>
          <span class="control cancel-btn" @click="deleteImage">{{$t('groups.deletePhoto')}}</span>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import API_SERVICE from "@/lib/api/messengerService";
const api = new API_SERVICE();
import S3_Handler from "@/lib/api/s3_handler";
const s3 = new S3_Handler();
const Modal = () => import("@/components/Modal");

import moment from "moment";
export default {
  components: {
    Modal
  },
  data() {
    return {
      groupDetailInfo: null,
      modalActive: false
    };
  },
  async beforeMount() {
    await this.getGroupInfo();
  },
  methods: {
    async getGroupInfo() {
      this.$store.commit("global/SET_LOADING", true);
      try {
        let id = this.$route.params.id;
        const response = await api.getGroupsById(id);
        let formatDate = moment(response.chat.createdAt).format(
          "DD/MM/YY, HH:mm a"
        );
        if (response.chat.image) {
          const signedUrl = s3.getSignedUrl(response.chat.image);
          response.chat.image = signedUrl;
        } else {
          response.chat.image = "";
        }
        response.chat.createdAt = formatDate;
        this.groupDetailInfo = response.chat;
      } catch (error) {
        console.log(error);

        this.$store.commit("global/SET_LOADING", false);
      } finally {
        this.$store.commit("global/SET_LOADING", false);
      }
    },
    async deleteImage() {
      this.$store.commit("global/SET_LOADING", true);
      try {
        let data = {
          chatId: this.$route.params.id
        };
        const response = await api.deleteGroupImage(data);
      } catch (error) {
        console.log(error);
        this.$store.commit("global/SET_LOADING", false);
      } finally {
        this.$store.commit("global/SET_LOADING", false);
        await this.getGroupInfo();
        this.closeModal();
      }
    },
    openModal: function() {
      this.modalActive = true;
    },
    closeModal: function() {
      this.modalActive = false;
    }
  }
};
</script>

<style>
.return {
  color: black;
}
.return:hover {
  color: black;
}
.bolded {
  font-weight: bold;
}
.right-col p {
  margin: 0;
}
.gray-image-detail {
  background-color: #cccccc;
  height: 250px;
  width: 25rem;
  margin-right: auto;
  margin-left: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.group-image-container {
  position: relative;
  width: 25rem;
  height: 250px;
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.group-image {
  position: relative;
}
.group-image-container img {
  width: 25rem;
  height: 250px;
}
.delete-icon-detail {
  position: absolute;
  bottom: 15px;
  right: 20px;
  font-size: 1.4rem;
  color: #000;
  cursor: pointer;
}
.controls {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
.controls span {
  cursor: pointer;
}
.messenger .modal-container {
  max-width: 25rem !important;
}
</style>